export function usePartnerSearchStyles(partnerForServiceRole: unknown) {
  return {
    minWidth: !partnerForServiceRole ? '36.5em' : '38.5em',
    '& .MuiFormHelperText-root': {
      mt: -1.5,
      ml: 0,
    },
    '& .MuiInputBase-root': {
      border: 'none',
      padding: 0,
      display: 'flex',
      color: 'black',
    },
    '& .MuiFormControl-root': {
      color: 'black',
    },
    '& .MuiInputBase-input': {
      border: 'none',
      padding: '8px',
      color: 'black',
      width: '21.5rem',
      marginBottom: '1rem',
    },
    '& .MuiOutlinedInput-input': {
      border: 'none',
      color: 'black',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none',
      color: 'black',
    },
    '& .MuiAutocomplete-endAdornment': {
      mt: -1,
    },
  };
}
